import emailjs from "emailjs-com";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "./Contact.css";
const ContactForm = () => {
  const { t } = useTranslation();
  const [formState, setFormState] = useState({
    fname: "",
    lname: "",
    phone: "",
    email: "",
    message: "",
  });
  const toastError = () => toast.error("ინფორმაცია არ გაიგზავნა!");
  const toastSuccess = () => toast.success("ინფორმაცია წარმატებით გაიგზავნა!");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_9x0gerb",
        "template_85my419",
        e.target,
        "y8FwJH_hHepe7erQI"
      )
      .then(
        (result) => {
          toastSuccess();
          console.log("Email sent!", result.status, result.text);
        },
        (error) => {
          console.error("Error sending email:", error);
          toastError();
        }
      );

    setFormState({
      fname: "",
      lname: "",
      phone: "",
      email: "",
      message: "",
    });
  };

  return (
    <section className="contact mtop">
      <div className="container flex">
        <div className="main-content">
          <h2>{t("contactForm")}</h2>
          <p>{t("fill")}</p>

          <form onSubmit={handleSubmit}>
            <div className="grid1">
              <div className="input">
                <span>{t("firstName")}</span>
                <input
                  type="text"
                  name="fname"
                  value={formState.fname}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input">
                <span>{t("lastName")}</span>
                <input
                  type="text"
                  name="lname"
                  value={formState.lname}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input">
                <span>{t("phone")}</span>
                <input
                  type="number"
                  name="phone"
                  value={formState.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <span>{t("email")}</span>
                <input
                  type="email"
                  name="email"
                  value={formState.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="input inputlast">
              <span>{t("message")}</span>
              <textarea
                cols="30"
                rows="10"
                name="message"
                value={formState.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button className="primary-btn">{t("submit")}</button>
          </form>
        </div>
        <div className="side-content">
          <h4>{t("visitLocation")} </h4>
          <p>{t("street")}</p>
          <h4 style={{ marginTop: "10px" }}>{t("numberTitle")}</h4>
          <span>{t("sharaNumber")}</span>
          <h4 style={{ marginTop: "10px" }}>{t("emailTitle")}</h4>
          <span>{t("sharaMail")}</span>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
